module.exports = __webpack_public_path__ + "static/img/pc_index_back.a2921c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/pc_index_back.png
// module id = Sm9h
// module chunks = 0